import React from "react";
import { MessageSquare } from "lucide-react";
import { Header } from "@/components/MobileShell";

export default function ChatsPage() {
  return (
    <>
      <Header title="Chats" subtitle="Communicate clearly" />
      <div className="px-7 pt-20 flex flex-col items-center text-center" data-testid="chats-placeholder">
        <div className="h-16 w-16 rounded-full bg-[#F1EEE7] flex items-center justify-center">
          <MessageSquare className="h-7 w-7 text-[#253B35]" strokeWidth={1.5} />
        </div>
        <h2 className="font-serif text-2xl text-[#1F2B26] mt-6">No conversations yet</h2>
        <p className="font-sans text-sm text-[#5F6D66] leading-relaxed mt-3 max-w-xs">
          Private, real-time messaging opens once you've accepted a connection — coming in the next milestone.
        </p>
      </div>
    </>
  );
}
